const validate = (...validators) => {
  return validators.reduce((result, func) => func() && result, true);
};

export { validate };
